import axios from "axios";

const url = process.env.VUE_APP_API_URL;

/* 创建实例 */
const INSTANCE = axios.create({
  baseURL: url,
  // baseURL: "https://grape-server.xsyxsc.com",
  timeout: 100000,
});

const messageQueue = [];

const singleTip = (type, msg) => {
  if (messageQueue.push({ type, msg }) === 1) {
    setTimeout(() => {
      let { type, msg } = messageQueue.shift();
      messageQueue.length = 0;
    }, 0);
  }
};

const getErrorText = (url, code) => {
  switch (code) {
    case 401:
      return `【${url}】接口鉴权错误，请检查鉴权参数！`;
    case 404:
      return `【${url}】接口地址错误，请检查接口是否存在！`;
    case 500:
      return `【${url}】接口服务器内部错误，请联系接口开发人员！`;
    default:
      return "系统繁忙，请稍后再试";
  }
};

/* INSTANCE.interceptors.request.use(
  config => {
    token = token || getToken();
    config.headers.common.Authorization = token;
    const { custom = { strategyName: "", bgLoading: false }, ...rest } = config;
    return _.merge(rest, custom);
  },
  error => {
    console.warn(error);
    return Promise.reject(error);
  }
); */

INSTANCE.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      /*  const { data } = response;
      if (data.rspCode !== "success") {
        Notification.error({
          title: data.rspDesc,
        });
      } */
      return Promise.resolve(response);
    } else {
      /*  const { data } = response;
       !response.config.silent &&
         singleTip(
           "error",
           data.data ||
           data.msg ||
           getErrorText(response.config.url, response.status)
         ); */
      return Promise.reject(response);
    }
  },
  (error) => {
    !error.response.config.silent &&
      singleTip(
        "error",
        getErrorText(error.response.config.url, error.response.status)
      );
    return Promise.reject(error);
  }
);

const request = ({ type, url, params, headers, custom = {} }) => {
  return new Promise((resolve, reject) => {
    INSTANCE.request({
      url,
      method: type,
      headers,
      [["post", "put"].includes(type) ? "data" : "params"]: params,
      custom,
    })
      .then((res) => {
        resolve(custom.getRoot ? res : res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export function get(url, params, headers, custom) {
  return request({ type: "get", url, params, headers, custom });
}

export function post(url, params, headers, custom) {
  return request({ type: "post", url, params, headers, custom });
}

export function put(url, params, custom) {
  return request({ type: "put", url, params, custom });
}

export function del(url, params, custom) {
  return request({ type: "delete", url, params, custom });
}

export default {
  get,
  put,
  post,
  del,
};
